import * as R from 'ramda'

export default function merge(subscriptions) {
  return () => {
    console.log('unsubscribing all suscriptions')

    R.forEach(subscription => subscription.complete(), subscriptions)
  }
}
